/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Aggregation {
    AVG = 'avg',
    COUNT = 'count',
    COUNT_DISTINCT = 'count-distinct',
    MAX = 'max',
    MIN = 'min',
    PERCENTILE = 'percentile',
    SUM = 'sum',
}
